import { getField, updateField } from 'vuex-map-fields'
import api from '../api'
import router from '@/router'

export const state = {
    keyword: '',

    params: {
        filter_by: '',
        page: 1,
    },

    list: {
        data: [],
        total: 1
    },

    selectedAccounts: [],

    loading: false,

    accountForm: {
        account_status: 1,
        company_name: '',
        first_name: '',
        last_name: '',
        country: {},
        zone_name: {},
        zip_code: '',
        contact_no: '',
        email: '',
        subscription_start: '',
        subscription_end: '',
        user_allocation: '',
        categories: '',
        price: '',
        password: '',
        password_confirmation: '',
        partner: {},
        company_type: {},
        country_code: {},
        partnerCountry: {}
    },

    hasUpdatedList: false,

    formLoading: false,
    isUpdateAccount: false,

    hasFormChangeChecker: {},
    hasFormChanged: false,

    isFormComplete: false,

    formPage: 1,

    isPageOneComplete: false
}

export const actions = {
    async createAccount({ state, commit, dispatch }, payload) {
        state.formLoading = true

        const { data, status } = await api('post', `cms/client/create`, payload)

        await commit('modal/toggleNotification', { notificationName: '' }, { root: true })

        if (status) {
            state.hasUpdatedList = true
            await commit('clearPage')

            state.list.data = data.data.data
            state.list.total = data.data.total

            await commit('modal/toggleNotification', {
                notificationName: 'notification-banner',
                notificationType: 'success',
                notificationDesc: 'Successfully created a client account.',
            }, { root: true })

            await dispatch('modal/closeModal', {}, { root: true })

            state.formLoading = false
            router.push({ name: 'account-request' })
            return
        }

        state.formLoading = false

        const errors = Object.keys(data.errors).reduce((result, item) => {
            const errorItem = `- ${data.errors[item].join(`<br> - `).replace(/\./g, '')}`

            result.push(errorItem)

            return result
        }, []).join('<br>')

        commit('modal/toggleNotification', {
            notificationName: 'notification-banner',
            notificationType: 'warning',
            notificationDesc: `${errors}.`,
        }, { root: true })
        return
    },

    async updateAccount ({ state, commit, dispatch }, payload) {
        state.formLoading = true

        const { data, status } = await api('post', `cms/client/update`, payload)

        await commit('modal/toggleNotification', { notificationName: '' }, { root: true })

        if (status) {
            state.hasUpdatedList = true
            await commit('clearPage')

            state.list.data = data.data.data
            state.list.total = data.data.total

            await commit('modal/toggleNotification', {
                notificationName: 'notification-banner',
                notificationType: 'success',
                notificationDesc: 'Successfully updated a client account.',
            }, { root: true })

            await dispatch('modal/closeModal', {}, { root: true })

            state.formLoading = false
            return
        }
        
        state.formLoading = false

        const errors = Object.keys(data.errors).reduce((result, item) => {
        const errorItem = `- ${data.errors[item].join(`<br> - `).replace(/\./g, '')}`

            result.push(errorItem)

            return result
        }, []).join('<br>')

        commit('modal/toggleNotification', {
            notificationName: 'notification-banner',
            notificationType: 'warning',
            notificationDesc: `${errors}.`,
        }, { root: true })
        return
        
    },

    async enableDisableAccount({ state, commit }, payload) {
        state.formLoading = true

        const { data, status } = await api('post', `cms/client/enable-disable`, payload)

        await commit('modal/toggleNotification', { notificationName: '' }, { root: true })

        if (status) {
            state.hasUpdatedList = true
            await commit('clearPage')

            state.list.data = data.data.data
            state.list.total = data.data.total
            state.hasUpdatedList = false

            await commit('modal/toggleNotification', {
                notificationName: 'notification-banner',
                notificationType: 'success',
                notificationDesc: 'Successfully updated account status.',
            }, { root: true })

            state.formLoading = false
            return
        }
        
        state.formLoading = false

        const errors = Object.keys(data.errors).reduce((result, item) => {
            const errorItem = `- ${data.errors[item].join(`<br> - `).replace(/\./g, '')}`

            result.push(errorItem)

            return result
        }, []).join('<br>')

        commit('modal/toggleNotification', {
            notificationName: 'notification-banner',
            notificationType: 'warning',
            notificationDesc: `${errors}.`,
        }, { root: true })
        return
    },

    async getAccountList({ state }, payload) {
        state.loading = true

        const { data } = await api('get', `${payload}`)

        state.list.data = data.data.data
        state.list.total = data.data.total

        state.loading = false
    }
}

export const mutations = {
    updateField,

    clearPage() {
        state.keyword = ''

        state.params = {
            filter_by: '',
            page: 1,
        }

        state.list = {
            data: [],
            total: 1
        }

		state.selectedAccounts = []

		state.loading = false

		state.hasUpdatedList = false
    },

    clearForm() {
        state.accountForm = {
            account_status: 1,
            company_name: '',
            first_name: '',
            last_name: '',
            country: {},
            zone_name: {},
            zip_code: '',
            contact_no: '',
            email: '',
            subscription_start: '',
            subscription_end: '',
            user_allocation: '',
            categories: '',
            price: '',
            password: '',
            password_confirmation: '',
            partner: {},
            company_type: {},
            country_code: {},
            partnerCountry: {}
        }

        state.hasFormChangeChecker = {}
        state.hasFormChanged = false

        state.isFormComplete = false

        state.formLoading = false
        state.isUpdateAccount = false

        state.hasUpdatedList = false

        state.formPage = 1
    },

    setFormChangedChecker() {
        state.hasFormChangeChecker = {
            ...JSON.parse(JSON.stringify(state.accountForm))
        }
    },

    hasFormChanged() {
        const accountForm = state.accountForm
        const formChecker = state.hasFormChangeChecker
        const stringifyObj = (obj) => JSON.stringify(obj)

        for (const property in accountForm) {
            const formProperty = accountForm[property]
            const formCheckerProperty = formChecker[property]

            if (typeof accountForm[property] === 'object') {
                const stringObjForm = stringifyObj(formProperty)
                const stringObjFormChecker = stringifyObj(formCheckerProperty)

                if (stringObjForm !== stringObjFormChecker) {
                    state.hasFormChanged = true
                    return
                }

            } else {
                if (formProperty !== formCheckerProperty) {
                    state.hasFormChanged = true
                    return
                }
            }
        }
    },

    isPageOneComplete (state) {
        state.isPageOneComplete = true

        const requiredFields = [
            'company_name', 'first_name', 'last_name',
            'email', 'contact_no', 'country', 'zone_name',
            'zip_code', 'password', 'password_confirmation',
            'company_type'
        ]

        for (let field of requiredFields) {
            const formProperty = state.accountForm[field]
            if (formProperty === '' || (
                formProperty && formProperty.constructor === Object
                && !Object.keys(formProperty).length
            )) {
                state.isPageOneComplete = false

                return
            }
        }
    },

    isFormComplete(state, isCreate = false) {
        state.isFormComplete = true
        const accountForm = state.accountForm
        const nonRequiredProperty = isCreate
            ? ['partner', 'partnerCountry']
            : ['partner', 'partnerCountry', 'password', 'password_confirmation']

        for (const property in accountForm) {
            const formProperty = accountForm[property]

            if (nonRequiredProperty.indexOf(property) === -1) {
                if (
                    formProperty === ''
                    || (formProperty.constructor === Object
                        && !Object.keys(formProperty).length)
                ) {
                    state.isFormComplete = false

                    return
                }
            }
        }
    }
}

const getters = {
    getField
}

export default {
    state,
    actions,
    mutations,
    getters,
    namespaced: true
}
